//返回el对象css样式中的property属性值
export function getStyle(el, property) {
    if (getComputedStyle) {
        return getComputedStyle(el)[property];
    } else {
        return el.currentStyle[property];
    }
}
/* 对el对象css样式中的属性值进行更改，更改的内容在properties里面，properties是一个
属性对象数组，对每一个properties里的每一个对象值进行修改，并且产生由快到慢的动画
效果变化 */
// export function animate(el, properties) {
//     console.log(properties)
//     clearInterval(el.timeId);
//     //产生动态效果的方法
//     el.timeId = setInterval(function () {
//         for (var property in properties) {
//             console.log(property)
//             var current;
//             var target = properties[property];
//             // current = parseInt(getStyle(el, property));
//             current = el[property];
//             //属性的变化速度（由快到慢）
//             var speed = (target - current) / 30;
//             console.log(current, target)
//             //ceil向上取整  floor向下取整
//             speed = speed > 0 ? Math.ceil(speed) : Math.floor(speed);

//             console.log(el[property], target)
//             //重新设置el对象 css中的样式
//             if (el[property] == target) {
//                 clearInterval(el.timeId);
//             }
//             console.log(current + speed + "px")
//             el.scrollTo({ top: 0, left: 0, behavior: 'smooth' });
//         }
//     }, 20);

// }